<template>
    <section id="location" class="section section--location">
        <div class="section__body">
            <h2 class="section__title">Informations</h2>
            <div class="layout">
                <div class="info">
                    <div class="info__section">
                        <h3 class="info__title"> Coordonnées </h3>
                        <div class="info__cols">
                            <div class="info__col info__col--large">
                                <div class="info__maps">
                                    <img class="info__map" alt="Localisation de Chez Nicos" src="https://cdn0.centralapp.com/api/v1/media/1/original?s=mapbox&amp;u=aHR0cHM6Ly9hcGkubWFwYm94LmNvbS9zdHlsZXMvdjEvbWFwYm94L3N0cmVldHMtdjEwL3N0YXRpYy9waW4tcys4YzQwNDQoMi4zNDk0Miw0OC44NDM2KS8yLjM0OTQyLDQ4Ljg0MzYsMTUsMCwwLzQwMHgyOTVAMng=">
                                    <div class="info__radius-map">
                                        <img class="" alt="Localisation de Chez Nicos" src="https://cdn0.centralapp.com/api/v1/media/1/original?s=mapbox&amp;u=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">
                                        <div class="info__radius-map-tooltip"> Zone desservie par Chez Nicos </div>
                                    </div>
                                </div>
                                <div class="info__radius-map">
                                    <img class="" alt="Localisation de Chez Nicos" src="https://cdn0.centralapp.com/api/v1/media/1/original?s=mapbox&amp;u=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">
                                    <div class="info__radius-map-tooltip"> Zone desservie par Chez Nicos </div>
                                </div>
                            </div>
                            <div class="info__col info__col">
                                <address class="list">
                                    <p class="list__item">
                                        <font-awesome-icon class="list__icon icon" :icon="['fas', 'map-marker-alt']" size="1x"/>
                                        <strong>Chez Nicos</strong><br> Rue Mouffetard 44<br> 75005 Paris<br> France
                                    </p>
                                    <p class="list__item list__item--group">
                                        <font-awesome-icon class="list__icon icon" :icon="['fas', 'phone-alt']" size="1x"/>
                                        <span data-event-type="click" data-event-info="location" data-event-action="contact_phone"> +33 1 45 87 28 13 </span>
                                    </p>
                                    <!-- <p class="list__item">
                                        <font-awesome-icon class="list__icon icon" :icon="['fas', 'envelope']" size="1x"/>
                                        <a href="/fr/contact?color=8c4044&amp;objective=food_delivery&amp;hide_poweredby=false&amp;hide_overlay=false&amp;hide_news=false&amp;dummy=true&amp;place_id=16736" data-event-type="click" data-event-info="location" data-event-action="contact_email"> Nous contacter </a>
                                    </p> -->
                                </address>
                                <div class="info__cta">
                                    <a target="_blank" class="button" href="https://www.google.be/maps/dir/?api=1&amp;destination=Rue Mouffetard+44+75005+Paris+France" data-event-type="click" data-event-info="location" data-event-action="directions"> Itinéraire </a>
                                </div>
                                <div id="opening-hours"></div>
                            </div>
                        </div>
                    </div>
                    <div class="info__section">
                        <div class="info__cols">
                            <div class="info__col">
                                <h3 class="info__title"> Heures d'ouverture </h3>
                                <div class="hours">
                                    <p class="hours__day" v-for="(dayItem, index) in daysOpenHours" :key="index" :class="{'hours__day--today': isCurrentDay(dayItem.labels.en)}"> <strong class="hours__name">{{ dayItem.labels.fr }}</strong> <span class="hours__slots"> {{ dayItem.schedule }} </span> </p>
                                </div>
                            </div>
                            <div class="info__col info__col--large">
                                <h3 class="info__title"> Informations complémentaires </h3>
                                <ul class="list list--tight">
                                    <li class="list__item">
                                        <font-awesome-icon class="list__icon icon" :icon="['fas', 'credit-card']" size="1x"/>
                                        Paiement: Cash, Visa, Mastercard, Carte de debit, Ticket Restaurant
                                    </li>
                                    <li class="list__item">
                                        <font-awesome-icon class="list__icon icon" :icon="['fas', 'wifi']" size="1x"/>
                                        Wi-fi gratuit
                                    </li>
                                    <li class="list__item">
                                        <font-awesome-icon class="list__icon icon" :icon="['fas', 'wheelchair']" size="1x"/>
                                        Accès personnes à mobilité réduite
                                    </li>
                                    <li class="list__item">
                                        <font-awesome-icon class="list__icon icon" :icon="['fas', 'concierge-bell']" size="1x"/>
                                        Services: Dîner, Déjeuner, Petit déjeuner, Desserts, Service tard le soir
                                    </li>
                                    <li class="list__item"> 
                                        <font-awesome-icon class="list__icon icon" :icon="['fas', 'temperature-low']" size="1x"/>
                                        Climatisation
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import moment from 'moment';

export default {
    methods: {
        isCurrentDay(dayLabel) {
            return moment().format('dddd') === dayLabel
        }
    },
    computed: {
        daysOpenHours() {
            return [
                {
                    labels: {
                        fr: 'Lundi',
                        en: 'Monday'
                    },
                    schedule: '10:00 — 02:00'
                },
                {
                    labels: {
                        fr: 'Mardi',
                        en: 'Tuesday'
                    },
                    schedule: '10:00 — 02:00'
                },
                {
                    labels: {
                        fr: 'Mercredi',
                        en: 'Wednesday'
                    },
                    schedule: '10:00 — 02:00'
                },
                {
                    labels: {
                        fr: 'Jeudi',
                        en: 'Thursday'
                    },
                    schedule: '10:00 — 02:00'
                },
                {
                    labels: {
                        fr: 'Vendredi',
                        en: 'Friday'
                    },
                    schedule: '10:00 — 02:00'
                },
                {
                    labels: {
                        fr: 'Samedi',
                        en: 'Saturday'
                    },
                    schedule: '10:00 — 02:00'
                },
                {
                    labels: {
                        fr: 'Dimanche',
                        en: 'Sunday'
                    },
                    schedule: '10:00 — 02:00'
                }
            ]
        }
    }
}
</script>

<style>
.info__section {
    margin-bottom: 3.5em;
    padding-bottom: 3.5em;
    border-bottom: 1px solid rgba(140, 64, 68, 0.25);
}
.info:last-child {
    margin-bottom: 0;
}
.info {
    margin-bottom: 4em;
    color: rgb(35, 16, 17);
}
.info__title {
    margin: 0 0 1.25em;
    color: #8c4044;
    line-height: 1.45em;
    font-size: 1.8em;
    font-weight: 500;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: .135em;
    text-indent: .135em;
}
.info__section:first-child .info__col {
    padding-top: 0;
    border-top: 0;
}
.info__col:first-child {
    padding-top: 0;
}
.info__col {
    position: relative;
    margin-bottom: 3.5em;
    padding-top: 3.5em;
}
.info__maps {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 48em;
    height: auto;
}
.info__radius-map {
    position: absolute;
    left: 6px;
    top: 6px;
    width: 33%;
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    border-radius: 0 0 .35rem 0;
}
.info__radius-map-tooltip {
    position: absolute;
    top: 100%;
    left: 50%;
    margin-top: .35rem;
    z-index: 10;
    padding: 1rem;
    display: none;
    border-radius: .33rem;
    background-color: #8c4044;
    color: #ffffff;
    font-size: 1.2rem;
    text-align: center;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    -o-transition: all .5s cubic-bezier(0.23,1,0.32,1);
    transition: all .5s cubic-bezier(0.23,1,0.32,1);
    -webkit-transform: scale(.7) translateX(-50%);
    -ms-transform: scale(.7) translateX(-50%);
    -o-transform: scale(.7) translateX(-50%);
    transform: scale(.7) translateX(-50%);
    -webkit-transform-origin: 0 50%;
    -ms-transform-origin: 0 50%;
    -o-transform-origin: 0 50%;
    transform-origin: 0 50%;
}
.info__radius-map-tooltip:after {
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -.5rem;
    content: "";
    height: 0;
    width: 0;
    pointer-events: none;
    border: .5rem solid transparent;
    border-bottom-color: #8c4044;
}

.list {
    margin: 0 auto 3.2em;
    padding: 0;
    list-style: none;
    max-width: 30em;
    font-size: 1.7em;
}
.list:last-child {
    margin-bottom: 0;
}
.list__item {
    position: relative;
    margin: 0 0 1.35em;
    padding-left: 2.2em;
    line-height: 1.3em;
}
.list__item:last-child {
    margin-bottom: 0;
}
.list--tight .list__item {
    margin-bottom: .66em;
}
.list__icon {
    position: absolute;
    top: 0;
    left: 0;
    height: 1em;
    line-height: 1em;
    font-size: 1.25em;
    color: rgb(178, 177, 177);
}
.icon {
    vertical-align: top;
    font-family: icons;
    font-style: normal;
    font-weight: 400;
    speak: none;
    display: inline-block;
    text-decoration: none;
    text-align: center;
    -webkit-font-feature-settings: normal;
    -moz-font-feature-settings: normal;
    font-feature-settings: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
address {
    font-style: normal;
}
.info__col:last-child {
    margin-bottom: 0;
    border-top: 1px solid rgba(140, 64, 68, 0.25);
}

.info__cta {
    margin: 0;
    text-align: center;
}
.hours {
    margin: -.5em auto;
    max-width: 26em;
    font-size: 1.4em;
}
.hours__day {
    margin: 0;
    display: table;
    width: 100%;
    padding: .8em;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(230, 230, 230);
    font-size: 1.3em;
}
.hours__day:last-child {
    border-bottom: 0;
}
.hours__name {
    width: 40%;
}
.hours__slots {
    width: 60%;
    text-align: right;
}
.hours__name, .hours__slots {
    display: table-cell;
    vertical-align: middle;
    height: 1.5em;
}
.hours__day--today {
    margin-top: -1px;
    color: #88b93b;
    border-top: 1px solid rgb(219, 234, 196);
    border-bottom-color: rgb(219, 234, 196);
    background: rgba(136, 185, 59, 0.05);
}
@media (min-width: 681px) {
    .info__section:first-child {
        border-top-width: 1px;
        border-top-left-radius: .66em;
        border-top-right-radius: .66em;
    }
    .info__section, .info__section:last-child {
        margin: 0;
        padding: 3.5em;
        background: #ffffff;
        border: 1px solid rgb(230, 230, 230);
        border-top-width: 0;
    }
    .info__title {
        margin: 0 0 1.6em;
        font-size: 1.5em;
        line-height: 1em;
        text-align: left;
        text-indent: 0;
    }
    .info__cols {
        display: table;
        table-layout: fixed;
        width: 100%;
    }
    .info__col {
        display: table-cell;
        width: 40%;
        vertical-align: top;
        border-left: 1.75em solid transparent;
        border-right: 1.75em solid transparent;
        padding-top: 0;
        padding-bottom: 0;
    }
    .info__col--large {
        width: 60%;
    }
    .info__col:first-child {
        border-left: 0;
    }
    .info__col:last-child {
        border-right: 0;
        border-top: 0;
    }
    .info__map {
        padding: 0;
        border: 0;
        border-radius: 0;
        background: none;
    }
    .info__radius-map {
        position: absolute;
        left: 0;
        top: 0;
    }
    .info__radius-map-tooltip {
        display: block;
    }
    .list {
        max-width: none;
        font-size: 1.5em;
    }
    .info__cta {
        text-align: left;
    }
    .hours {
        margin-left: 0;
        margin-right: 0;
        max-width: 21em;
    }
    .hours__day {
        margin-left: -.8em;
        margin-right: -.8em;
        font-size: 1em;
    }
}
</style>